import api from './api';

// Sugestão de referência (codbar) para o produto novo: a última referência + 1, como no ERP desktop.
// Vazio quando não há sugestão (referência não numérica) ou a chamada falha: a sugestão nunca bloqueia a ficha.
export async function buscarProximaReferencia(): Promise<string> {
  try {
    const response = await api.get('/proximaReferencia');
    return String(response.data?.codbar ?? '').trim();
  } catch {
    return '';
  }
}
